"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAndGetQuery = void 0;
const query_string_1 = __importDefault(require("query-string"));
const deepmerge_1 = __importDefault(require("deepmerge"));
exports.parseAndGetQuery = (location, strict = false, keys = ['access_token', 'user']) => {
    const query = query_string_1.default.parse(location.search);
    return new Promise((resolve, reject) => {
        const params = deepmerge_1.default.all(keys.map((key) => {
            if (strict) {
                if (!query[key])
                    reject(new Error(`Missing information: ${key}`));
            }
            return { [key]: query[key] };
        }));
        return resolve(params);
    });
};
//# sourceMappingURL=parse-params.js.map